import React from 'react';
import { Button } from 'react-bootstrap';

/**
 * "Ask AI" from anywhere in the dashboard: the floating ChatWidget listens for
 * this event and opens expanded, on a fresh chat, with `text` as its first
 * message. An event rather than a second chat — the same door the header uses
 * to open the command palette.
 */
export const ASK_AI_EVENT = 'ph:ask-ai';

export const askAI = (text) => {
  window.dispatchEvent(new CustomEvent(ASK_AI_EVENT, { detail: { text } }));
};

/** The question an invoicing agent asks first about a booking (or a group). */
export const correspondencePrompt = (refs) => (
  `Summarise the correspondence for ${refs.length > 1 ? 'bookings' : 'booking'} ${refs.join(', ')}`
  + ' — what was discussed, agreed and still open, with anything relevant to invoicing'
  + ' (company/VAT details, invoice recipient, payment).'
);

/** A small "Ask AI" that asks about the given booking references. */
function AskAIButton({ refs, onAsk = () => {}, className = '' }) {
  const known = refs.filter(Boolean);
  if (!known.length) return null;
  return (
    <Button
      size="sm"
      variant="outline-primary"
      className={className}
      onClick={() => {
        onAsk();
        askAI(correspondencePrompt(known));
      }}
      title="Summarise this booking's correspondence in the assistant"
      aria-label={`Ask AI about ${known.join(', ')}`}
    >
      <i className="fa fa-magic me-1" aria-hidden="true" />
      Ask AI
    </Button>
  );
}

export default AskAIButton;
